import ApiService from '../apiservice'

export default class StatusAtividadeService extends ApiService {
  constructor() {
    super('/statusAtividade')
  }

  cadastrar(status) {
    return this.post('/',status);
  }

  consultar(codigo) {
    return this.get(`/${codigo}`);
  }

  listarStatus(empresa) {
    return this.get(`/all/${empresa}`);
  }

  alterar(status) {
    return this.put('/',status);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}